module.exports = __webpack_public_path__ + "static/media/exchange-02.85e46f2c.webm";